import Api, { FetchMethodType } from './Api';

export interface ShiftImpactLine {
  icon: string;
  text: string;
}

export interface ShiftImpactExplainer {
  greeting: string;
  context?: string;
  lines: ShiftImpactLine[];
}

export interface ShiftImpact {
  explainer: ShiftImpactExplainer;
}

export interface GetShiftImpactParams {
  applicationId: string;
  shiftId: number;
}

export interface AICoachShiftImpactApi {
  getShiftImpact(params: GetShiftImpactParams): Promise<ShiftImpact>;
}

export default class AICoachShiftImpactRestApi extends Api implements AICoachShiftImpactApi {
  public async getShiftImpact({ applicationId, shiftId }: GetShiftImpactParams): Promise<ShiftImpact> {
    return this.fetch<ShiftImpact>(`/aiCoach/shiftImpact/${applicationId}?shiftId=${shiftId}`, {
      method: FetchMethodType.GET,
    });
  }
}
